import { Spin } from "antd";
import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

import { useProject, useToken } from 'utils/utility';

import styles from './PrivateRoute.module.scss';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export function PrivateRoute ({ children }) {
  const { token, success, loading } = useToken();
  const { project } = useProject();
  
  const query = useQuery();

  const isLoggedIn = token;
  const secure_token = query.get("secure_token");

  if (loading || !success)
    return <Spin className={styles.centered} />;

  if (!isLoggedIn && !secure_token)
    return <Navigate to={`/sign-in?app=${project === 'project-planner' ? 'pp' : project === 'decision-manager' ? 'dm' : ''}`} replace />

  return children;
}

export function GuestRoute({ children }) {
  const { token, loading, success } = useToken();
  const savedApp = Cookies.get("lmos-default-app");

  if (loading || !success)
    return <Spin className={styles.centered} />

  if (token)
    return <Navigate to={`/${savedApp === 'pp' ? 'project-planner' : 'decision-matrix'}`} replace />

  return children;
}
